// extracted by mini-css-extract-plugin
export var cardHeader = "_fr-1";
export var contentCard = "_fr-0";
export var headerActions = "_fr-3";
export var reorderHandle = "_fr-5";
export var titleArea = "_fr-2";
export var titleAreaWithHandle = "_fr-4";